import(/* webpackMode: "eager" */ "/home/ubuntu/download/699b1f31f782d500140b62ed/helium_fulfilment/src/app/admin/page.tsx");
